'use client';

import React, { Suspense } from 'react';
import ServicesBackground from './ServicesBackground';
import ServiceCatalog from './ServiceCatalog';
import UnifiedProcess from './UnifiedProcess';
import PricingTiers from './PricingTiers';
import TechStackModern from './TechStackModern';
import WhyChooseUs from './WhyChooseUs';

export default function ServicesInteractive() {
    return (
        <div className="min-h-screen relative overflow-hidden bg-slate-50/50">
            {/* Shared Background for Continuity */}
            <ServicesBackground />

            {/* Content Sections */}
            <div className="relative z-10 flex flex-col gap-0">
                <ServiceCatalog />
                <UnifiedProcess />
                <Suspense fallback={<div className="py-24 text-center">Loading pricing...</div>}>
                    <PricingTiers />
                </Suspense>
                <TechStackModern />
                <WhyChooseUs />
            </div>
        </div>
    );
}
